import { IHoliday } from "../holidayTypes";

export const SpainHolidays: { [key: string]: IHoliday } = {
  // 2024
  "2024-01-01": { title: "Año Nuevo", type: "HOLIDAY" },
  "2024-01-06": { title: "Epifanía del Señor", type: "HOLIDAY" },
  "2024-03-29": { title: "Viernes Santo", type: "HOLIDAY" },
  "2024-04-01": { title: "Lunes de Pascua", type: "SPECIAL_DAY" }, // Firad i vissa regioner
  "2024-05-01": { title: "Día del Trabajo", type: "HOLIDAY" },
  "2024-08-15": { title: "Asunción de la Virgen", type: "HOLIDAY" },
  "2024-10-12": { title: "Fiesta Nacional de España", type: "HOLIDAY" },
  "2024-11-01": { title: "Día de Todos los Santos", type: "HOLIDAY" },
  "2024-12-06": { title: "Día de la Constitución", type: "HOLIDAY" },
  "2024-12-08": { title: "Inmaculada Concepción", type: "HOLIDAY" },
  "2024-12-25": { title: "Navidad", type: "HOLIDAY" },

  // 2025
  "2025-01-01": { title: "Año Nuevo", type: "HOLIDAY" },
  "2025-01-06": { title: "Epifanía del Señor", type: "HOLIDAY" },
  "2025-04-17": { title: "Jueves Santo", type: "HOLIDAY" }, // Observeras i vissa regioner
  "2025-04-18": { title: "Viernes Santo", type: "HOLIDAY" },
  "2025-04-21": { title: "Lunes de Pascua", type: "HOLIDAY" }, // Observeras i vissa regioner
  "2025-05-01": { title: "Día del Trabajo", type: "HOLIDAY" },
  "2025-08-15": { title: "Asunción de la Virgen", type: "HOLIDAY" },
  "2025-10-12": { title: "Fiesta Nacional de España", type: "HOLIDAY" },
  "2025-11-01": { title: "Día de Todos los Santos", type: "HOLIDAY" },
  "2025-12-06": { title: "Día de la Constitución", type: "HOLIDAY" },
  "2025-12-08": { title: "Inmaculada Concepción", type: "HOLIDAY" },
  "2025-12-25": { title: "Navidad", type: "HOLIDAY" },
  "2025-12-31": { title: "Nochevieja", type: "SPECIAL_DAY" },

  // 2026
  "2026-01-01": { title: "Año Nuevo", type: "HOLIDAY" },
  "2026-01-06": { title: "Epifanía del Señor", type: "HOLIDAY" },
  "2026-04-02": { title: "Jueves Santo", type: "HOLIDAY" }, // Observeras i vissa regioner
  "2026-04-03": { title: "Viernes Santo", type: "HOLIDAY" },
  "2026-04-06": { title: "Lunes de Pascua", type: "HOLIDAY" }, // Observeras i vissa regioner
  "2026-05-01": { title: "Día del Trabajo", type: "HOLIDAY" },
  "2026-08-15": { title: "Asunción de la Virgen", type: "HOLIDAY" },
  "2026-10-12": { title: "Fiesta Nacional de España", type: "HOLIDAY" },
  "2026-11-01": { title: "Día de Todos los Santos", type: "HOLIDAY" },
  "2026-12-06": { title: "Día de la Constitución", type: "HOLIDAY" },
  "2026-12-08": { title: "Inmaculada Concepción", type: "HOLIDAY" },
  "2026-12-25": { title: "Navidad", type: "HOLIDAY" },
  "2026-12-31": { title: "Nochevieja", type: "SPECIAL_DAY" },

  // 2027
  "2027-01-01": { title: "Año Nuevo", type: "HOLIDAY" },
  "2027-01-06": { title: "Epifanía del Señor", type: "HOLIDAY" },
  "2027-03-25": { title: "Jueves Santo", type: "HOLIDAY" }, // Observeras i vissa regioner
  "2027-03-26": { title: "Viernes Santo", type: "HOLIDAY" },
  "2027-03-29": { title: "Lunes de Pascua", type: "HOLIDAY" }, // Observeras i vissa regioner
  "2027-05-01": { title: "Día del Trabajo", type: "HOLIDAY" },
  "2027-08-15": { title: "Asunción de la Virgen", type: "HOLIDAY" },
  "2027-10-12": { title: "Fiesta Nacional de España", type: "HOLIDAY" },
  "2027-11-01": { title: "Día de Todos los Santos", type: "HOLIDAY" },
  "2027-12-06": { title: "Día de la Constitución", type: "HOLIDAY" },
  "2027-12-08": { title: "Inmaculada Concepción", type: "HOLIDAY" },
  "2027-12-25": { title: "Navidad", type: "HOLIDAY" },
  "2027-12-31": { title: "Nochevieja", type: "SPECIAL_DAY" },
};



// WEBPACK FOOTER //
// ./src/constants/holidays/europe/spainHolidays.ts